import { makeAutoObservable } from "mobx";
import Storage from "utils/storage";
import { AppModalTransferProps } from "@/components/App/modal/transfer";
import { AppModalBorrowRepayProps } from "components/app/modal/borrowRepay";
import { AppModalSubscribeRedeemProps } from "components/app/modal/subscribeRedeem";

export enum TradeSideEnum {
  sell = "SELL",
  buy = "BUY",
}

export enum TradeTypeEnum {
  limit = "LIMIT",
  market = "MARKET",
}

export enum TradeOrderStateEnum {
  NEW = "NEW",
  FILLED = "FILLED",
  PARTIALLY_FILLED = "PARTIALLY_FILLED",
  CANCELED = "CANCELED",
  REJECTED = "REJECTED",
  EXPIRED = "EXPIRED",
}

export enum LayoutAdvancedActiveKeyEnum {
  order = "order",
  trade = "trade",
}

export enum LayoutH5ActiveKeyEnum {
  chart = "chart",
  order = "order",
  trade = "trade",
}

export interface TickerProps {
  s: string;
  c?: string;
  cr?: string;
  cv?: string;
  h?: string;
  l?: string;
  q?: string;
  v?: string;
}

export interface TradeRecentProps {
  b: boolean;
  i: number;
  p: string;
  q: string;
  t: number;
  v: string;
}

interface TradeRecentOnceProps extends ObjAny {
  p: string;
  q: string;
  total?: string;
  isClick?: boolean;
}

export type DepthAryProps = Array<Array<string>>;

interface LeverWsLiquidationRateProps extends ObjAny {
  marketName: string;
  liquidationRate: string;
}

interface StateProps {
  tickers: TickerProps[];
  tradeRecent: WithUndefined<TradeRecentProps | null>;
  tradeRecentOnce: WithUndefined<TradeRecentOnceProps | null>;
  depthAsks: WithUndefined<DepthAryProps>;
  depthBids: WithUndefined<DepthAryProps>;
  isMaintainTip: boolean;
  leverWsLiquidationRate: WithUndefined<LeverWsLiquidationRateProps>;
  cfdTicker: WithUndefined<TickerProps>;
  modalTransfer: WithUndefined<AppModalTransferProps>;
  modalBorrowRepay: WithUndefined<AppModalBorrowRepayProps>;
  modalSubscribeRedeem: WithUndefined<AppModalSubscribeRedeemProps>;
  layoutAdvancedActiveKey: LayoutAdvancedActiveKeyEnum;
  layoutH5ActiveKey: LayoutH5ActiveKeyEnum;
  orderConfirm_limit: boolean;
  orderConfirm_market: boolean;
  closeConfirm_position: boolean;
  cfdPositionClosedPositionId: WithUndefined<string>;
}

const trade = makeAutoObservable(
  {
    tickers: [] as StateProps["tickers"],
    tradeRecent: undefined as StateProps["tradeRecent"],
    tradeRecentOnce: undefined as StateProps["tradeRecentOnce"],
    depthAsks: undefined as StateProps["depthAsks"],
    depthBids: undefined as StateProps["depthBids"],
    isMaintainTip: false as StateProps["isMaintainTip"],
    leverWsLiquidationRate: undefined as StateProps["leverWsLiquidationRate"],
    cfdTicker: undefined as StateProps["cfdTicker"],
    modalTransfer: undefined as StateProps["modalTransfer"],
    modalBorrowRepay: undefined as StateProps["modalBorrowRepay"],
    modalSubscribeRedeem: undefined as StateProps["modalSubscribeRedeem"],
    layoutAdvancedActiveKey: LayoutAdvancedActiveKeyEnum.order as StateProps["layoutAdvancedActiveKey"],
    layoutH5ActiveKey: LayoutH5ActiveKeyEnum.chart as StateProps["layoutH5ActiveKey"],
    orderConfirm_limit: true as StateProps["orderConfirm_limit"],
    orderConfirm_market: true as StateProps["orderConfirm_market"],
    closeConfirm_position: true as StateProps["closeConfirm_position"],
    cfdPositionClosedPositionId: undefined as StateProps["cfdPositionClosedPositionId"],

    updateState(payload: Partial<StateProps>) {
      for (const key in payload) {
        this[key] = payload[key];
      }
    },

    initOrderConfirm() {
      this.orderConfirm_limit = (() => {
        const value = Storage.get("orderConfirm_limit");
        return value !== false;
      })();
      this.orderConfirm_market = (() => {
        const value = Storage.get("orderConfirm_market");
        return value !== false;
      })();
      this.closeConfirm_position = (() => {
        const value = Storage.get("closeConfirm_position");
        return value !== false;
      })();
    },
  },
  {},
  {
    autoBind: true,
    deep: false,
  }
);

export default trade;
